import React from 'react';
import { Button } from '@/components/ui/button';

/** client#9: all pending shift requests for one shift (oldest first); the admin approves one of them.
 *  `shift.pickup_requests = [{staff_id, staff_name, requested_at}]` (legacy single requester folded in by the API). */
export function pickupRequestsOf(shift) {
  const reqs = (shift?.pickup_requests || []).filter(r => r && r.staff_id);
  if (!reqs.length && shift?.pickup_requested_by) return [{ staff_id: shift.pickup_requested_by, staff_name: shift.pickup_requested_by_name || null }];
  return reqs;
}

export function hasMyPickupRequest(shift, userId) {
  return !!userId && pickupRequestsOf(shift).some(r => r.staff_id === userId);
}

function when(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '' : d.toLocaleString('en-AU', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
}

export function PickupRequestsList({ shift, onApprove, approvingId, disabled }) {
  const reqs = pickupRequestsOf(shift);
  if (!reqs.length) return null;
  return (
    <ul className="space-y-1.5" data-testid="pickup-requests-list">
      {reqs.map((r, i) => (
        <li key={r.staff_id} className="flex items-center justify-between gap-2 rounded border bg-white/70 px-2 py-1.5" data-testid={`pickup-request-${r.staff_id}`}>
          <div className="min-w-0">
            <p className="text-xs font-medium truncate">{r.staff_name || 'A staff member'}</p>
            <p className="text-[10px] text-muted-foreground">{i === 0 ? 'First request' : `Request ${i + 1}`}{when(r.requested_at) ? ` · ${when(r.requested_at)}` : ''}</p>
          </div>
          <Button size="sm" className="h-7 bg-emerald-600 hover:bg-emerald-700" disabled={disabled || !!approvingId}
            onClick={() => onApprove(r.staff_id)} data-testid={`approve-pickup-${r.staff_id}`}>
            {approvingId === r.staff_id ? 'Approving…' : 'Approve'}
          </Button>
        </li>
      ))}
    </ul>
  );
}
